var _rect, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#184985",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 32 37.5 24A14 14 0 1 0 37.5 40Z",
    fill: "#184985"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 32,
    r: 1.6,
    fill: "#184985"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 32,
    r: 1.6,
    fill: "#184985"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25.5,
    r: 2.4,
    fill: "#FDDB44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacman);
export default __webpack_public_path__ + "static/media/pacman.af4d34e99040737ad52f45d69bb9fbc5.svg";
export { ForwardRef as ReactComponent };